<template>
  <div class="disease">
    <Search title="疾病风险" :attent="num + '项需关注'" :total="'共计评价' + total + '种疾病'" :child="child" backurl="/home">
      <div class="box">
        <van-tabs v-model="activeTab">
          <van-tab style="position: relative;">
            <div slot="title" style="position: relative" @click="showActionSheet0">
              <span>{{ child === 1 ? '儿童时期高风险' : '高风险疾病'}}</span>
              <i v-if="showDropDown" class="icon-down" @click="isShowBottom"></i>
              <i v-if="showDropDown === false" class="icon-down1" @click="isShowTop"></i>
            </div>

            <div class="action-sheet" v-show="showDropDown">
              <ul v-if="gdb3">
                <li @click="riskSort" :class="{ active: sortType === 1 }">
                  按患病风险倍数排序
                  <i class="iconfont icon-dui"></i>
                </li>
                <li @click="rateSort" :class="{ active: sortType === 2 }">
                  按终身患病风险排序
                  <i class="iconfont icon-dui"></i>
                </li>
              </ul>
              <ul v-if="gdb2">
                <li @click="handleRiskSort" :class="{ active: sortType === 1 }">
                  <div @click="showDropDown = false">
                    按患病风险倍数排序
                    <i class="iconfont icon-dui"></i>
                  </div>
                </li>
                <li @click="handleRateSort" :class="{ active: sortType === 2 }">
                  <div @click="showDropDown = false">
                    按终身患病风险排序
                    <i class="iconfont icon-dui"></i>
                  </div>
                </li>
              </ul>
            </div>

            <div v-show="gdb3">
              <div v-if="diseasesDate.length === 0 && !loading"  class="noCarry">
                <img src="../../assets/images/nothing1.png" alt="未携带">
              </div>

              <div v-else v-for="(item, index) in diseasesDate" :key="item.id || index" class="risk-cell" @click="$router.push({path: '/diseaseInfo/' + item.id + '/' + item.type})">
                <p class="title">{{ item.name }}</p>
                <p v-if="item.type !== 'disease'">风险评估：{{ item.result }}</p>
                <p v-else class="detail">患病风险倍数：<span>{{ item.risk_level }}</span>&nbsp;&nbsp;&nbsp;&nbsp;终身患病风险：<span>{{ item.risk_of_illness | fixed(4) }}%</span></p>
              </div>
            </div>
            <div v-show="gdb2">
              <div v-if="diseasesDate.length === 0 && !loading"  class="noCarry">
                <img src="../../assets/images/nothing1.png" alt="未携带">
              </div>
              <div v-else>
                <div v-for="(item, index) in diseasesDateOther" :key="item.id || index" class="risk-cell" @click="$router.push({path: '/diseaseInfo/' + item.itemid + '/tumour'})">
                  <p class="title">{{ item.chname }}</p>
                  <p>风险评估: 遗传性位点筛查检出高风险变异位点</p>
                </div>
                <div v-for="(item, index) in diseasesDate" :key="item.id || index" class="risk-cell" @click="$router.push({path: '/diseaseInfo/' + item.itemid + '/' + (item.status ? 'tumour' : 'disease')})">
                  <p class="title">{{ item.chname }}</p>
                  <p class="detail">患病风险倍数：<span>{{ item.risk }}</span>&nbsp;&nbsp;&nbsp;&nbsp;终身患病风险：<span>{{ item.rate }}%</span></p>
                </div>
              </div>
            </div>
          </van-tab>

          <van-tab v-if="child === 1" style="position: relative;">
            <div slot="title" style="position: relative" @click="showActionSheet1">
              <span>其他时期高风险</span>
              <i v-if="showDropDown1" class="icon-down" @click="isShowBottom1"></i>
              <i v-if="showDropDown1 === false" class="icon-down1" @click="isShowTop1"></i>
            </div>

            <div class="action-sheet" v-show="showDropDown1">
              <ul>
                <li @click="otherRiskSort" :class="{ active: otherSortType === 1 }">
                  按患病风险倍数排序
                  <i class="iconfont icon-dui"></i>
                </li>
                <li @click="otherRateSort" :class="{ active: otherSortType === 2 }">
                  按终身患病风险排序
                  <i class="iconfont icon-dui"></i>
                </li>
              </ul>
            </div>

            <div>
              <div v-if="diseasesDateOther.length === 0 && !loading"  class="noCarry">
                <img src="../../assets/images/nothing1.png" alt="未携带">
              </div>

              <div v-else v-for="(item, index) in diseasesDateOther" :key="item.id || index" class="risk-cell" @click="$router.push({path: '/diseaseInfo/' + item.id + '/' + item.type})">
                <p class="title">{{ item.name }}</p>
                <p v-if="item.type !== 'disease'">风险评估：{{ item.result }}</p>
                <p v-else class="detail">患病风险倍数：<span>{{ item.risk_level }}</span>&nbsp;&nbsp;&nbsp;&nbsp;终身患病风险：<span>{{ item.risk_of_illness | fixed(4) }}%</span></p>
              </div>
            </div>
          </van-tab>

          <van-tab>
            <div slot="title" @click="showActionSheet3">
              <span>按系统浏览</span>
            </div>
            <Grids :gridsType="diseaseSystems" systems="diseaseType"></Grids>
          </van-tab>
        </van-tabs>
      </div>
    </Search>
  </div>
</template>

<script>
import Search from '@/components/Search'
import Grids from '@/components/Grids'
import { Toast } from 'vant'
export default {
  name: 'index',
  data () {
    return {
     sample_type: this.util.getLS(this.api.sample_type),
      gdb2: false,
      gdb3: false,
      num: '',
      total: '',
      activeTab: parseInt(this.$route.query.activeTab),
      showDropDown: false,
      showDropDown1: false,
      times: 1,
      times1: 1,
      sortType: 1, // 高风险默认排序
      otherSortType: 1, // 其他时期高风险默认排序
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      diseasesDate: [],
      diseasesDateOther: [],
      diseaseSystems: [],
      loading: true
    }
  },
  methods: {
    // 数量接口
    getQuantity () {
      this.util.get(this.api.diseases_quantity, '', (success) => {
        this.num = success.num
        this.total = success.total
      })
    },
    // 成人时期 高风险疾病
    getDiseases () {
      this.util.get(this.api.high_diseases + '?sortType=' + this.sortType, '', (success) => {
        this.diseasesDate = success.items
        this.loading = false
        this.util.setLS('paginationData', success.items)
      })
    },
    
    // 其他时期 高风险疾病
    getDiseasesOther () {
      this.util.get(this.api.adult_high_diseases + '?sortType=' + this.otherSortType, '', (success) => {
        this.diseasesDateOther = success.items
        this.loading = false
        this.util.setLS('paginationData', success.items)
      })
    },
    // 儿童时期 高风险疾病
    getDiseasesChild () {
      this.util.get(this.api.children_high_diseases + '?sortType=' + this.sortType, '', (success) => {
        this.diseasesDate = success.items
        this.loading = false
        this.util.setLS('paginationData', success.items)
      })
    },
    // 下拉框
    isShowTop () {
      this.showDropDown1 = false
      this.showDropDown = true
    },
    isShowBottom () {
      this.showDropDown1 = false
      this.showDropDown = false
    },
    showActionSheet0 () {
      this.$router.push({path: '/disease?num=' + this.num + '&total=' + this.total + '&activeTab=0'})
      if (this.gdb3 === true) {
        if (this.child === 1) {
          this.getDiseasesChild()
        } else {
          this.getDiseases()
        }
      } else {
        this.getHighLevelDisease()
      }
    },
    // 下拉框
    isShowTop1 () {
      this.showDropDown1 = true
      this.showDropDown = false
    },
    isShowBottom1 () {
      this.showDropDown1 = false
      this.showDropDown = false
    },
    showActionSheet1 () {
      this.$router.push({path: '/disease?num=' + this.num + '&total=' + this.total + '&activeTab=1'})
      this.getDiseasesOther()
    },
    showActionSheet3 () {
      if (this.child === 1) {
        this.$router.push({path: '/disease?num=' + this.num + '&total=' + this.total + '&activeTab=2'})
      } else {
        this.$router.push({path: '/disease?num=' + this.num + '&total=' + this.total + '&activeTab=1'})
      }
    },
    // 成人时期 高风险疾病 按患病风险倍数排序
    riskSort () {
      this.sortType = 1
      this.showDropDown = false
      if (this.child === 1) {
        this.getDiseasesChild()
        Toast('已按患病风险倍数排序')
      } else {
        this.getDiseases()
        Toast('已按患病风险倍数排序')
      }
    },
    // 成人时期 高风险疾病 按终身患病风险排序
    rateSort () {
      this.sortType = 2
      Toast('已按终身患病风险排序')
      this.showDropDown = false
      if (this.child === 1) {
        this.getDiseasesChild()
      } else {
        this.getDiseases()
        Toast('已按患病风险倍数排序')
      }
    },
    // 儿童时期 高风险疾病 按患病风险倍数排序
    otherRiskSort () {
      this.otherSortType = 1
      this.getDiseasesOther()
      Toast('按患病风险倍数排序')
      this.showDropDown1 = false
    },
    // 儿童时期 高风险疾病 按终身患病风险排序
    otherRateSort () {
      this.otherSortType = 2
      this.getDiseasesOther()
      Toast('已按终身患病风险排序')
      this.showDropDown1 = false
    },
    // 按系统浏览
    getDiseaseSystems () {
      this.util.get(this.api.disease_systems, '', (success) => {
        console.log(success)
        if(this.sample_type === 'childwes_zy'){
          this.diseaseSystems = [
              { icon: 'iconzhongliu', title: '肿瘤系统', num: success.items.肿瘤, id: '肿瘤' },
              { icon: 'iconxinnaoxieguan', title: '心脑血管', num: success.items.心脑血管, id: '心脑血管' },
              { icon: 'iconanquan', title: '免疫系统', num: success.items.免疫系统, id: '免疫系统' },
              { icon: 'iconweiai', title: '消化系统', num: success.items.消化系统, id: '消化系统' },
              { icon: 'iconwaimao', title: '眼部疾病', num: success.items.眼部疾病, id: '眼部疾病' },
              { icon: 'iconshuiguo1', title: '内分泌及营养代谢', num: success.items.内分泌及营养代谢, id: '内分泌及营养代谢' },
              { icon: 'icon-huxidaojibing', title: '呼吸系统', num: success.items.呼吸系统, id: '呼吸系统' },
              { icon: 'iconminiao', title: '泌尿生殖', num: success.items.泌尿生殖, id: '泌尿生殖' },
              { icon: 'iconshenjingyuan', title: '神经系统', num: success.items.神经系统, id: '神经系统' },
              { icon: 'iconjirouliang', title: '骨骼肌肉', num: success.items.骨骼肌肉, id: '骨骼肌肉' },
              { icon: 'iconmeirong1', title: '皮肤系统', num: success.items.皮肤系统, id: '皮肤系统' },
              { icon: 'iconbingjun', title: '感染类疾病', num: success.items.感染类疾病, id: '感染类疾病' },
              { icon: 'iconclinicblood', title: '血液系统', num: success.items.血液系统, id: '血液系统' },
               { icon: 'icon-fashao', title: '解热镇痛药物', num: success.items.解热镇痛药物, id: '解热镇痛药物' },
               { icon: 'icon-mazuiqian', title: '麻醉类药物', num: success.items.麻醉类药物, id: '麻醉类药物' },
               { icon: 'icon-guominshi', title: '抗过敏药物', num: success.items.抗过敏药物, id: '抗过敏药物' }
        ]}else{
            this.diseaseSystems = [
              { icon: 'iconzhongliu', title: '肿瘤系统', num: success.items.肿瘤, id: '肿瘤' },
              { icon: 'iconxinnaoxieguan', title: '心脑血管', num: success.items.心脑血管, id: '心脑血管' },
              { icon: 'iconanquan', title: '免疫系统', num: success.items.免疫系统, id: '免疫系统' },
              { icon: 'iconweiai', title: '消化系统', num: success.items.消化系统, id: '消化系统' },
              { icon: 'iconshuiguo1', title: '营养代谢', num: success.items.内分泌及营养代谢, id: '内分泌及营养代谢' },
              { icon: 'icon-huxidaojibing', title: '呼吸系统', num: success.items.呼吸系统, id: '呼吸系统' },
              { icon: 'iconminiao', title: '泌尿生殖', num: success.items.泌尿生殖, id: '泌尿生殖' },
              { icon: 'iconshenjingyuan', title: '神经系统', num: success.items.神经系统, id: '神经系统' },
              { icon: 'iconjirouliang', title: '骨骼肌肉', num: success.items.骨骼肌肉, id: '骨骼肌肉' },
              { icon: 'iconmeirong1', title: '皮肤系统', num: success.items.皮肤系统, id: '皮肤系统' },
              { icon: 'iconear', title: '眼耳鼻喉', num: success.items.眼耳鼻喉, id: '眼耳鼻喉' },
              { icon: 'iconbingjun', title: '感染类疾病', num: success.items.感染类疾病, id: '感染类疾病' },
              { icon: 'iconclinicblood', title: '血液系统', num: success.items.血液系统, id: '血液系统' },
              { icon: 'icon-fashao', title: '解热镇痛药物', num: success.items.解热镇痛药物, id: '解热镇痛药物' },
               { icon: 'icon-mazuiqian', title: '麻醉类药物', num: success.items.麻醉类药物, id: '麻醉类药物' },
               { icon: 'icon-guominshi', title: '抗过敏药物', num: success.items.抗过敏药物, id: '抗过敏药物' }
            ]
        }    
      })
    },
    // gdb2
    // 疾病信息
    getHighLevelDisease () {
      let that = this
      that.gdb2 = true
      this.util.get1(this.api.highLevelDisease, '', (success) => {
        that.num = success.follow_num
        that.total = success.sum
        let sort = that.util.getLS(that.api.lsHighLvDisSort) || 'risk'
        that.sortType = sort
        that.diseasesDate = success.disease
        that.diseasesDateOther = success.inheritance
        if (sort === 'risk') {
          that.handleRiskSort()
        } else {
          that.handleRateSort()
        }
      })
    },
    // 高危险疾病 按患病风险倍数排序方法
    handleRiskSort () {
      this.sortType = 1
      // Toast('已按患病风险倍数排序')
      this.diseasesDate.sort(function (a, b) {
        return b.risk - a.risk
      })
      this.util.setLS(this.api.lsHighLvDisSort, 'risk')
    },
    // 高危险疾病 按终身患病风险排序方法
    handleRateSort () {
      this.sortType = 2
      // Toast('已按终身患病风险排序')
      this.diseasesDate.sort(function (a, b) {
        return b.rate - a.rate
      })
      this.util.setLS(this.api.lsHighLvDisSort, 'rate')
    },
    getDiseaseSystems1 () {
      this.diseaseSystems = [
        { icon: 'iconzhongliu', title: '肿瘤系统', id: '肿瘤' },
        { icon: 'iconxinnaoxieguan', title: '心脑血管', id: '心脑血管' },
        { icon: 'iconanquan', title: '免疫系统', id: '免疫系统' },
        { icon: 'iconweiai', title: '消化系统', id: '消化系统' },
        { icon: 'iconshuiguo1', title: '营养代谢', id: '内分泌及营养代谢' },
        { icon: 'icon-huxidaojibing', title: '呼吸系统', id: '呼吸系统' },
        { icon: 'iconminiao', title: '泌尿生殖', id: '泌尿生殖' },
        { icon: 'iconshenjingyuan', title: '神经系统', id: '神经系统' },
        { icon: 'iconjirouliang', title: '骨骼肌肉', id: '骨骼肌肉' },
        { icon: 'iconmeirong1', title: '皮肤系统', id: '皮肤系统' },
        { icon: 'iconear', title: '眼耳鼻喉', id: '眼耳鼻喉' }
      ]
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      if (this.child === 1) {
        if(this.activeTab === 0){
          this.getDiseasesChild()
        }else if(this.activeTab === 1){
          this.getDiseasesOther()
        }
      } else {
        this.getDiseases()
      }
      this.getQuantity()
      this.getDiseaseSystems()
    } else {
      this.gdb2 = true
      this.getHighLevelDisease()
      this.getDiseaseSystems1()
    }
  },
  watch: {
    '$route' (to) {
      this.activeTab = parseInt(to.query.activeTab)
      this.showDropDown1 = false
      this.showDropDown = false
    }
  },
  components: {
    Search,
    Grids,
    Toast
  },
  beforeRouteUpdate (to, from, next) {
    this.activeTab = parseInt(to.query.activeTab)
    next()
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/functions";
  .disease {
    height: 100%;
    background-color: #fff;

    .van-tab{
      padding: 0;

      span {
        display: inline-block;
      }
    }

    .van-hairline--top-bottom::after {
      border: none;
    }

    .van-tab--active {
      color: #007aff;
    }

    .detail span{
      color: #007aff;
    }
  }

  .icon-down {
    width: 0;
    height: 0;
    border: pxToRem(14px) solid transparent;
    border-top-color: #00BBD3;
    position: relative;
    top: pxToRem(25px);
  }
  .icon-down1 {
    width: 0;
    height: 0;
    border: pxToRem(14px) solid transparent;
    border-bottom-color: #00BBD3;
    position: relative;
    top: pxToRem(-23px);
  }

  /* 下拉菜单 */
  .action-sheet {
    position: absolute;
    top: pxToRem(-20px);
    z-index: 999;
    left: 0;
    right: 0;
    background: #FEFDEF;
    color: #9F9FA0;
    padding: 10px 0;
    margin-top: -2px;

    li {
      padding: 10px 2.5em;
      text-align: left;
      position: relative;

      &.active {
        color: #007aff;

        .icon-dui {
          display: block;
        }
      }

      .icon-dui {
        display: none;
        font-size: pxToRem(30px);
        position: absolute;
        right: 3em;
        bottom: 15px;
        color: #007aff;
      }
    }
  }

  .dropDownMask {
    background: rgba(0, 0, 0, .2);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .mint-tab-item-label{
    font-size: pxToRem(20px) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/disease/index.vue